import React from 'react';
import ClientPortalView from './ClientPortalView';

const ClientPortalDemo = () => {
  // Realistic mock quote data for demonstration
  const mockQuote = {
    id: 1,
    title: 'Mediterranean Dream Cruise',
    destination: 'Mediterranean Sea',
    travel_start_date: '2026-07-15',
    travel_end_date: '2026-07-22',
    passenger_count: 2,
    total_amount: 4500.00,
    total_paid: 1500.00,
    deposit_amount: 1500.00,
    final_payment_date: '2026-06-15',
    agent_name: 'Sarah Johnson',
    agent_business_name: 'Wharfside Travel',
    agent_email: 'sarah@wharf sidetravel.com',
    agent_phone: '(555) 123-4567',
    agent_logo_url: 'https://ui-avatars.com/api/?name=Sarah+Johnson&background=2563eb&color=fff&size=128',
    agent_notes: 'This is a premium Mediterranean cruise experience! We\'ve secured you a balcony cabin with ocean views. Don\'t forget to bring your passport and any necessary visas. I\'ve also included some optional shore excursions that you can add to your booking.',
    destination_image: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?w=1600&h=900&fit=crop',
    components: [
      {
        type: 'flight',
        name: 'Outbound Flight - NYC to Barcelona',
        date: '2026-07-15',
        time: '18:30',
        description: 'Direct flight from JFK to Barcelona-El Prat Airport. Flight duration: 7 hours 30 minutes.',
        location: 'John F. Kennedy International Airport',
        price: 850.00
      },
      {
        type: 'hotel',
        name: 'Pre-Cruise Hotel Stay',
        date: '2026-07-15',
        description: 'One night at the Barcelona Marriott Hotel Auditorium. Check-in after 3 PM.',
        location: 'Barcelona, Spain',
        price: 200.00
      },
      {
        type: 'cruise',
        name: '7-Night Mediterranean Cruise',
        date: '2026-07-16',
        time: '17:00',
        description: 'Embark on Royal Caribbean\'s Harmony of the Seas. Balcony stateroom with ocean views. Ports: Barcelona, Marseille, Florence, Rome, Naples, Palma de Mallorca.',
        location: 'Port of Barcelona',
        price: 2600.00
      },
      {
        type: 'activity',
        name: 'Shore Excursion - Rome Highlights',
        date: '2026-07-19',
        time: '09:00',
        description: 'Guided tour of the Colosseum, Roman Forum, and Vatican City. Includes skip-the-line tickets and transportation.',
        location: 'Rome, Italy',
        price: 150.00
      },
      {
        type: 'flight',
        name: 'Return Flight - Barcelona to NYC',
        date: '2026-07-23',
        time: '11:00',
        description: 'Direct flight from Barcelona-El Prat Airport to JFK. Flight duration: 8 hours 45 minutes.',
        location: 'Barcelona-El Prat Airport',
        price: 700.00
      }
    ]
  };

  return (
    <div>
      <ClientPortalView quote={mockQuote} />
    </div>
  );
};

export default ClientPortalDemo;
